import { Toast } from 'components'
const fallbackCopyTextToClipboard = (text: string, onCopiedTriggered?: (content?: string, err?: unknown) => void) => {
  const textArea = document.createElement('textarea')
  textArea.value = text

  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
    onCopiedTriggered?.(text, undefined)
    Toast.toastMessage({ message: 'copied_to_clipboard', variant: 'info' })
  } catch (err) {
    onCopiedTriggered?.(undefined, err)
    console.error('Unable to copy', err)
  }

  document.body.removeChild(textArea)
}
export const copyTextToClipboard = (text: string, onCopiedTriggered?: (content?: string, err?: unknown) => void) => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text, onCopiedTriggered)
    return
  }
  navigator.clipboard.writeText(text).then(
    function () {
      Toast.toastMessage({ message: 'copied_to_clipboard', variant: 'info' })
      onCopiedTriggered?.(text, undefined)
    },
    function (err) {
      onCopiedTriggered?.(undefined, err)
    },
  )
}
